module.exports = __webpack_public_path__ + "static/media/new-Nippon-logo.d97f04b7.png";